import { render, staticRenderFns } from "./home.pug?vue&type=template&id=748497aa&"
import script from "./home.js?vue&type=script&lang=js&"
export * from "./home.js?vue&type=script&lang=js&"
import style0 from "./home.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports